"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTeamRecordResponseSchema = exports.ListTeamRecordQuerySchema = exports.GetTeamRecordResponseSchema = exports.TeamRecordSchema = exports.TeamRecordFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.TeamRecordFields = {
    teamId: core_1.IdSchema,
    subjectId: (0, core_1.Nullable)(core_1.IdSchema),
    timestamp: core_1.TimestampSchema,
    type: ruby_1.HistoryRecordTypeSchema,
    level: ruby_1.HistoryLevelSchema,
    before: common_1.RecordBeforeSchema,
    after: common_1.RecordAfterSchema,
};
exports.TeamRecordSchema = (0, core_1.StrictObject)({
    ...exports.TeamRecordFields,
    ...core_1.ModelMetaFields,
}, { title: "Team Record", description: "Record relating to a team" });
exports.GetTeamRecordResponseSchema = exports.TeamRecordSchema;
exports.ListTeamRecordQuerySchema = (0, core_1.createSortedPaginationQuerySchema)({
    subjectId: typebox_1.Type.Optional(core_1.IdSchema),
    ...core_1.DateFilterFields,
    type: (0, core_1.OptionalArrayQueryType)(ruby_1.HistoryRecordTypeSchema),
    level: typebox_1.Type.Optional(ruby_1.HistoryLevelSchema),
}, core_1.TimestampSort);
exports.ListTeamRecordResponseSchema = (0, core_1.createSortedListResponseSchema)(exports.TeamRecordSchema, core_1.TimestampSort);
